import React from 'react';
import { motion } from 'framer-motion';
import { StoreButtons } from './StoreButtons';
import { QrCode } from './QrCode';
import { PhoneFrame } from './phone/PhoneFrame';
import { EventScreen } from './screens/EventScreen';
const ease = [0.23, 1, 0.32, 1] as const;
export function DownloadCta() {
  return <section id="download" className="px-5 pb-20 lg:px-8 lg:pb-24" aria-labelledby="download-title" data-id="element-43" data-mp="21zss3t3ymdfs">
      <div className="leaf-xl relative mx-auto grid max-w-7xl overflow-hidden bg-mint lg:grid-cols-12" data-id="element-44" data-mp="1ea86t3kc343c">
        <div className="relative z-10 px-6 py-12 sm:px-12 lg:col-span-7 lg:p-16" data-id="element-45" data-mp="19betbb51rd36">
          <h2 id="download-title" className="font-display text-4xl font-bold leading-[1.02] tracking-[-0.035em] text-forest-deep sm:text-5xl lg:text-6xl" data-id="element-46" data-mp="1nz884tmb6bkp">
            Get more out of every event.
          </h2>
          <p className="mt-6 max-w-md text-lg leading-relaxed text-forest-deep/75" data-id="element-47" data-mp="vgktnx1thusl">
            Download AVEGA and get more out of the events you're already going to.
          </p>
          <div className="mt-10 flex flex-wrap items-center gap-6" data-id="element-48" data-mp="i3xf1chlyphq">
            <StoreButtons tone="onLight" data-id="element-49" data-mp="m58vosii80ds" />
            <div className="hidden items-center gap-3 sm:flex" data-id="element-50" data-mp="m47iahe0n1sw">
              <div className="rounded-2xl bg-white p-2" data-id="element-51" data-mp="qxsbzx8kt9ma">
                <QrCode size={60} data-id="element-52" data-mp="vvu417nzcj9w" />
              </div>
              <p className="text-sm font-semibold leading-snug text-forest-deep/75" data-id="element-53" data-mp="vuisums7g98r">
                Scan to
                <br data-id="element-54" data-mp="3vcs3ffdqb08v" />
                download
              </p>
            </div>
          </div>
        </div>
        <div className="relative hidden min-h-[440px] lg:col-span-5 lg:block" data-id="element-55" data-mp="39925d9voos3">
          <div className="absolute left-1/2 top-12 -translate-x-1/2" data-id="element-56" data-mp="84oe1zobsalv">
            <motion.div initial={{
            opacity: 0,
            y: 80
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.3
          }} transition={{
            duration: 0.3,
            ease
          }} style={{
            rotate: 6
          }} data-id="element-57" data-mp="d5m6d531ul13">
              <PhoneFrame label="Event page in the AVEGA app" data-id="element-58" data-mp="ywdkxvvyck1j">
                <EventScreen data-id="element-59" data-mp="yuiwi7lh29sp" />
              </PhoneFrame>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}